'use client'

import { Tabs } from '@/components/ui/tabs'
import { TCollectionFormatted } from '@/types/collection'
import { usePathname } from 'next/navigation'
import { useCollectionStore } from '../../store/collection-store'
import { updateUrl } from '../../utils/filter-utils'

type Props = {
  collection: TCollectionFormatted
  optionsCustom?: {
    label: string
    value: string
  }[]
}

export const FilterTabs = ({ collection, optionsCustom }: Props) => {
  const pathname = usePathname()

  const setFilter = useCollectionStore((s) => s.setFilter)
  const filter = useCollectionStore((s) => s.filter)

  const options =
    optionsCustom ||
    collection?.filter?.attributes?.[0]?.items?.map((item) => {
      return {
        label: item.title,
        value: item.seo_alias,
      }
    }) ||
    []

  const filterTabs = [
    {
      label: 'Tất cả',
      value: 'all',
    },
    ...options,
  ]

  const seoAlias = collection?.filter?.attributes?.[0]?.seo_alias || ''
  const onChangeTab = (value: string) => {
    if (value === 'all') {
      setFilter({})
      updateUrl(pathname, { scroll: false })
      return
    }

    setFilter({
      [seoAlias]: value,
    })
    updateUrl(`${pathname}?${seoAlias}=${value}`, { scroll: false })
  }

  return (
    <Tabs
      options={filterTabs}
      variant='filter'
      wrapperClassName='gap-2'
      onChange={onChangeTab}
      defaultValue={(filter[seoAlias] as string) || 'all'}
      triggerClassName='lg:h-10.5 lg:px-6 lg:py-2 lg:text-base lg:leading-6.5'
      size='small'
    />
  )
}
